import React from 'react';
import { Spinner } from '../Spinner';
import { Stack } from '../Stack';
import { Portal } from '../../internal/Portal';
export const TableLoadingPanel = ({ portal }) => {
    const loadingPanel = (React.createElement("div", { className: "k-loading-mask" },
        React.createElement(Stack, { alignItems: "center", justifyContent: "center", className: "h-100" },
            React.createElement(Spinner, null)),
        React.createElement("div", { className: "k-loading-color" })));
    return (React.createElement(Portal, { conditional: !!portal, target: typeof portal !== 'boolean' ? portal : undefined }, loadingPanel));
};
//# sourceMappingURL=TableLoadingPanel.js.map